export enum AuditInfoEnum {
    COMPANY_ID_KEY = 'companyId',
    DEPT_ID_KEY = 'deptId',
}
  